import { render, staticRenderFns } from "./dui-date-dropdowns.vue?vue&type=template&id=6ff84c48&scoped=true&"
import script from "./dui-date-dropdowns.vue?vue&type=script&lang=js&"
export * from "./dui-date-dropdowns.vue?vue&type=script&lang=js&"
import style0 from "./dui-date-dropdowns.vue?vue&type=style&index=0&id=6ff84c48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff84c48",
  null
  
)

export default component.exports